import { useTranslation } from 'react-i18next';
import { ChangeEvent, useRef } from 'react';
import { useQuery } from '@apollo/client';
import { Select } from '../../../ui/Select';
import { SORTING_VARIANTS } from '../../../../utils/helpers/constants';
import {
  SortingContainer,
  SelectedValueContainer,
  borderedSortingStyles
} from './styled';
import { SelectHorizontalAlignmentEnum } from '../../../ui/Select/types';
import { NewRadioButton } from '../../../NewRadioButton';
import { FilterFieldProps, SelectRefType } from '../types';
import { getDataForTransformationsQuery } from '../../../../api/queries';
import { GetDataForTransformationsQuery } from '../../../../graphql/graphql';
import { SortIcon } from '../../../../icons/Sort';
import { getPashaFilterDataQuery } from '../../../../api/queries/pasha';
import { getBasedDataStatValueInFilters } from '../../../../utils/helpers/common';
import { ItemConnectionSort } from '../../../../graphql/types';
import useScreenSize from '../../../../hooks/useScreenSize';
import { modalStyles } from '../../../Residences/SortingFilter/styled';
import { useSorting } from '../../../../hooks/useSorting';
import { PriceViewMode } from '../../../GeneralAdsPage/types';
import { denormalizeSort } from '../../../../utils/helpers/sortMapping';

export const SortingFilter = ({
  submitOnChange = false,
  isPerUnit = false,
  showIcon = true,
  initialSort,
  isPashaLanding
}: FilterFieldProps) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const { currentSort, updateSort } = useSorting();
  const currentSortValue = denormalizeSort(initialSort || currentSort);
  const basedDataStat = getBasedDataStatValueInFilters(isPashaLanding);

  const selectRef = useRef<SelectRefType>(null);

  const { data } = useQuery<GetDataForTransformationsQuery>(
    isPashaLanding ? getPashaFilterDataQuery : getDataForTransformationsQuery,
    { fetchPolicy: isPashaLanding ? 'cache-first' : 'cache-only' }
  );

  const value = SORTING_VARIANTS.find(
    variant => variant.id === currentSortValue
  );

  const selectedValue = (
    <SelectedValueContainer>
      <SortIcon />
      {!isSmall ? t(value?.name || '') : ''}
    </SelectedValueContainer>
  );

  const sortingPlaceholder = `${t('search.buttons.sort')}`;

  const onChangeRadioHandler = (event?: ChangeEvent<HTMLInputElement>) => {
    if (!event) return;

    const sortValue = event.target.value as ItemConnectionSort;

    updateSort(
      sortValue,
      isPerUnit ? PriceViewMode.PerAcre : PriceViewMode.PerArea,
      { sortData: data?.sort, isPashaLanding }
    );

    if (submitOnChange && selectRef.current) {
      selectRef.current.closePopover();
    }
  };

  return (
    <Select
      ref={selectRef}
      placeholder={sortingPlaceholder}
      value={selectedValue}
      cypress={`${basedDataStat}-sorting-modal`}
      stat={`${basedDataStat}-sorting-modal`}
      horizontalAlign={SelectHorizontalAlignmentEnum.Right}
      width={251}
      modalTitle={t('search.buttons.sort')}
      styles={borderedSortingStyles}
      modalCypress="filter-modal"
      showIcon={isPashaLanding ? showIcon : !isSmall}
      stylesModal={modalStyles}
      ariaLabel="Sort"
    >
      <SortingContainer>
        {SORTING_VARIANTS.map(sorting => (
          <NewRadioButton
            data={{ ...sorting, name: t(sorting.name) }}
            key={sorting.id}
            cypress="sorting"
            stat={sorting.stat}
            name="sorting"
            currentValue={currentSortValue}
            onChangeHandler={onChangeRadioHandler}
          />
        ))}
      </SortingContainer>
    </Select>
  );
};
